
const titles = {
    '/': 'Home - Codify',
    '/hero': 'Welcome to c0dify',
    '/login': 'Login - Codify',
    '/signup': 'Create an Account - Codify',
    '/about': 'About - Codify',
    '/profile': 'Profile - Codify',
    '/challenges': 'Challenges - Codify',
    '/meta': 'meta-codify',
    '/code': 'Code - C0dify',
    '/contests': 'Contests - Codify',
    '/contests/create': "Create Contest - Codify",
};

export default titles;